class WorkItemFormCleanDataModel {
  constructor(data) {
    this.id = data.id || null;
    this.data = data.data || "";
    this.label = data.label || null;
  }
}

export default WorkItemFormCleanDataModel;
